<div class="bell-wrap">
  <button
    class="bell-btn"
    [class.has-unread]="unreadCount > 0"
    (click)="toggleDropdown()"
    [title]="'notification_bell.title' | translate"
  >
    <svg
      class="bell-icon"
      [class.ringing]="unreadCount > 0"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
    </svg>
    <span class="bell-badge" *ngIf="unreadCount > 0">{{ unreadDisplay }}</span>
  </button>

  <div class="dropdown" [class.open]="isDropdownOpen">
    <div class="dropdown-header">
      <span class="dropdown-header-title">{{ 'notification_bell.title' | translate }}</span>
      <button class="mark-read-btn" (click)="markAllRead()">{{ 'notification_bell.mark_all_read' | translate }}</button>
    </div>

    <ng-container *ngIf="latestEntries.length > 0">
      <div class="notif-item" *ngFor="let entry of latestEntries" (click)="openChangelog()">
        <div class="notif-item-title-row">
          <span class="tag" [ngClass]="getTagClass(getEntryTag(entry))">{{ getTagLabel(getEntryTag(entry)) | translate }}</span>
          <span class="notif-item-title">{{ entry.title }}</span>
        </div>
        <div class="notif-item-date">{{ entry.created_at | date:'d MMMM yyyy' }}</div>
      </div>
    </ng-container>

    <div class="notif-empty" *ngIf="latestEntries.length === 0">{{ 'notification_bell.empty' | translate }}</div>

    <div class="dropdown-footer" (click)="openChangelog()">
      {{ 'notification_bell.view_all' | translate }} &rarr;
    </div>
  </div>
</div>
